import { useContext } from 'react';
import { CardSummaryContext, CardSummaryContextValue } from './CardSummaryContext';

/** Returns the card summary state, or null when no provider is present (e.g. create/builder). */
export function useCardSummary(): CardSummaryContextValue | null {
  return useContext(CardSummaryContext);
}
